<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <template v-if="warning.show">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Atenção!</h4>
                        <p class="mb-0">{{warning.message}}</p>
                    </div>                
                </template>
                <template v-else-if="leagues.length">
                    <div class="w-100 mb-3">
                        <div class="row" :class="{'d-contents w-100': platform == 'mobile'}">
                            <div class="col" :class="{'w-100 p-0': platform == 'mobile'}">
                                <input class="form-control" type="text" v-model="search" placeholder="Buscar liga...">
                            </div>
                            <div class="col-auto text-white mt-2" :class="{'w-100 p-0 mb-2': platform == 'mobile'}">
                                <template v-if="platform == 'desktop'">
                                    Total: {{leagues.length}}
                                </template>
                                <template v-else>
                                    <div class="float-left">Total:</div>
                                    <div class="float-right mb-2">{{leagues.length}}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <template v-if="filteredListLeagues.length">
                        <div id="accordion">
                            <collection-cluster data-theme="dark" v-bind="collection" :items="filteredListLeagues" :style="{height: screen_innerHeight + 'px'}">
                                <div class="card rounded-0" slot="item" slot-scope="{ cell, item }" :key="cell.index" :ref="item._id" :class="{'bg-danger': filteredListLeagues[cell.index].pre_jogo == 2}">
                                    <div class="card-header" :id="`heading-${cell.index}`">
                                        <h5 class="mb-0">
                                            <button class="btn" :class="{'collapsed': cell.index > 0, 'text-white': filteredListLeagues[cell.index].pre_jogo == 2}" data-toggle="collapse" :data-target="`#collapse-${cell.index}`" aria-expanded="true" :aria-controls="`#collapse-${cell.index}`">
                                                {{ item.nome }}
                                            </button>
                                        </h5>
                                    </div><!-- /card-header -->
                                    <div :id="`collapse-${cell.index}`" class="collapse" :aria-labelledby="`heading-${cell.index}`" data-parent="#accordion">
                                        <div class="card-body">
                                            <div class="row align-items-center">
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`id-${cell.index}`">ID</label>
                                                </div>
                                                <div class="col-8">
                                                    <input class="form-control" :id="`id-${cell.index}`" v-model="filteredListLeagues[cell.index]._id" @click="copyClipboard($event)" readonly autocomplete="off" spellcheck="false">
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`api-${cell.index}`">B365-ID</label>
                                                </div>
                                                <div class="col-8">
                                                    <input class="form-control" :id="`api-${cell.index}`" v-model="filteredListLeagues[cell.index].id" :readonly="block" autocomplete="off" spellcheck="false">
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`goal-api-${cell.index}`">GOAL-ID</label>
                                                </div>
                                                <div class="col-8">
                                                    <input class="form-control" :id="`goal-api-${cell.index}`" v-model="filteredListLeagues[cell.index].gs_league_id" :readonly="block" autocomplete="off" spellcheck="false">
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`league-${cell.index}`">Liga</label>
                                                </div>
                                                <div class="col-8">
                                                    <input class="form-control" :id="`league-${cell.index}`" v-model="filteredListLeagues[cell.index].nome" :readonly="block" autocomplete="off" spellcheck="false">
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`league-cc-${cell.index}`">Liga-CC</label>
                                                </div>
                                                <div class="col-8">
                                                    <input class="form-control" :id="`league-cc-${cell.index}`" v-model="filteredListLeagues[cell.index].liga_cc" :readonly="block" autocomplete="off" spellcheck="false">
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`cards-${cell.index}`">Cartões</label>
                                                </div>
                                                <div class="col-8">
                                                    <select class="form-control" :id="`cards-${cell.index}`" v-model="filteredListLeagues[cell.index].cartoes" :disabled="block">
                                                        <option value="sim" :selected="filteredListLeagues[cell.index].cartoes == 'sim'">Sim</option>
                                                        <option value="nao" :selected="filteredListLeagues[cell.index].cartoes == 'nao'">Não</option>
                                                    </select>
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`corners-${cell.index}`">Escanteios</label>
                                                </div>
                                                <div class="col-8">
                                                    <select class="form-control" :id="`corners-${cell.index}`" v-model="filteredListLeagues[cell.index].escanteios" :disabled="block">
                                                        <option value="sim" :selected="filteredListLeagues[cell.index].escanteios == 'sim'">Sim</option>
                                                        <option value="nao" :selected="filteredListLeagues[cell.index].escanteios == 'nao'">Não</option>
                                                    </select>
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`show-${cell.index}`">Inserir</label>
                                                </div>
                                                <div class="col-8">
                                                    <select class="form-control" :id="`show-${cell.index}`" v-model="filteredListLeagues[cell.index].inserir" :disabled="block">
                                                        <option value="1" :selected="filteredListLeagues[cell.index].inserir == 1">Sim</option>
                                                        <option value="2" :selected="filteredListLeagues[cell.index].inserir == 2">Não</option>
                                                    </select>
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-4">
                                                    <label class="text-dark" :for="`show-${cell.index}`">Exibir</label>
                                                </div>
                                                <div class="col-8">
                                                    <select class="form-control" :id="`show-${cell.index}`" v-model="filteredListLeagues[cell.index].pre_jogo" :disabled="block">
                                                        <option value="1" :selected="filteredListLeagues[cell.index].pre_jogo == 1">Sim</option>
                                                        <option value="2" :selected="filteredListLeagues[cell.index].pre_jogo == 2">Não</option>
                                                    </select>
                                                </div>
                                                <div class="w-100 mt-2"></div>
                                                <div class="col-12">
                                                    <button class="btn btn-block btn-success" @click="saveEditions(cell.index)" :disabled="block">
                                                        <i class="fas fa-save mr-2"></i>Salvar alterações
                                                    </button>
                                                </div>
                                            </div><!-- /row -->
                                        </div><!-- /card-body -->
                                    </div><!-- /collapse -->
                                </div><!-- /card -->
                            </collection-cluster>
                        </div><!-- /accordion -->
                    </template>
                </template>
            </div>
        </div>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CollectionCluster from 'vue-collection-cluster'

const heightAdjustMobile = 150;
const heightAdjustDesktop = 150;
const heightAdjust = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? heightAdjustMobile : heightAdjustDesktop;

export default {
    data() {
        return {
            search: '',
            block: false,
            current: 1,
            pageSize: 100,
            warning: {
                show: false,
                message: ''
            },
            collection: {
                heightType: 'automatic',
                // itemHeight: 46
            },
            leagues: [],
            loading: false,
            screen_innerHeight: window.innerHeight - heightAdjust,
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Navbar,
        Loading,
        CollectionCluster
    },
    methods: {
        saveEditions(index) {

             try {

                const self = this;
                const league = self.filteredListLeagues[index];

                if (league.id.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o API-ID da liga!',
                        'warning'
                    );
                } else if (league.nome.toString().trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o nome da liga!',
                        'warning'
                    );
                } else {

                    Swal.fire({
                        title: 'Salvar alterações',
                        html: `Você deseja mesmo salvar as alterações da liga <p class="mb-0"><b>${league.nome}</b></b> ?</p>`,
                        showCancelButton: true,
                        confirmButtonColor: '#28a745',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancelar',
                        confirmButtonText: 'Sim'
                    }).then((result) => {

                        if (result.value) {

                            self.loading = true;

                            api.post('liga', {
                                liga: league
                            }).then((response) => {
                                switch(response.data.result) {
                                    case 'success':
                                        Swal.fire(
                                            'Parabéns!',
                                            'As alterações foram salvas com sucesso!',
                                            'success'
                                        );
                                    break;
                                    default:
                                        Swal.fire(
                                            'Atenção',
                                            response.data.message,
                                            'warning'
                                        );
                                    break;
                                }
                            }).catch((error) => {
                                try {
                                    Swal.fire(
                                        'Falha',
                                        self.network_erros[error.status]['message'],
                                        'warning'
                                    );
                                } catch(e) {
                                    Swal.fire(
                                        'Falha',
                                        self.network_erros[408]['message'],
                                        'warning'
                                    );
                                }
                            }).finally(() => {
                                self.loading = false;
                            });
                        }
                    });
                }
             }
             catch(e)
             {
                Swal.fire(
                    'Atenção!',
                    'A liga não está disponível, atualize a página e tente novamente!',
                    'warning'
                );
             }
        },
        removeAccents(str) {
            
            let string = str;
            let map = {a : /[\xE0-\xE6]/g, A : /[\xC0-\xC6]/g, e : /[\xE8-\xEB]/g, E : /[\xC8-\xCB]/g, i : /[\xEC-\xEF]/g, I : /[\xCC-\xCF]/g, o : /[\xF2-\xF6]/g, O : /[\xD2-\xD6]/g, u : /[\xF9-\xFC]/g, U : /[\xD9-\xDC]/g, c : /\xE7/g, C : /\xC7/g, n : /\xF1/g, N : /\xD1/g};

            for (let key in map) {
                 let rex = map[key];
                 string = string.replace(rex, key);
            }

            return string;
        },
        copyClipboard(event) {
            navigator.clipboard.writeText(event.target.value).then(() => {
                Swal.fire(
                    'Parabéns!',
                    'O <strong>ID</strong> foi copiado com sucesso!',
                    'success'
                )
            }, () => {
                Swal.fire(
                    'Erro!',
                    'Não foi possível copiar o <strong>ID</strong>!',
                    'error'
                )
            });            
        },
        prev() {
            this.current--;
        },
        next() {
            this.current++;
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.platform = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
        });
    },
    computed: {
        indexStart() {
            return (this.current - 1) * this.pageSize;
        },
        indexEnd() {
            return this.indexStart + this.pageSize;
        },
        totalPaginated() {
            return Math.ceil(this.leagues.length / this.pageSize);
        },
        filteredListLeagues() {
            return this.leagues.filter((item) => {
                return this.removeAccents(item.nome).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim())
            });
        }
    },
    beforeMount() {
        try {

            const {pipe} = JSON.parse(localStorage.getItem('auth'));

            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
    created() {

        const self = this;

        self.loading = true;
        self.warning.show = false;

        api.get('ligas').then((response) => {
            switch(response.data.result) {
                case 'success':
                    self.leagues = response.data.leagues.sort((a, b) => {
                        return self.removeAccents(a.nome).localeCompare(self.removeAccents(b.nome));
                    });
                break;
                default:
                    self.warning.show = true;
                    self.warning.message = response.data.message;
                break;
            }
        }).catch((error) => {
            try {
                self.warning.show = true;
                self.warning.message = self.network_erros[error.status]['message'];
            } catch(e) {
                self.warning.show = true;
                self.warning.message = self.network_erros[408]['message'];
            }
        }).finally(() => {
            self.loading = false;
        })
    }
}
</script>

<style scoped>
.collection-cluster {
    width: 100%;
    overflow-x: auto;
}
.collection-cluster.desktop::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.collection-cluster.desktop::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: .25rem;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb:active {
  background: #ddd;
}
.collection-cluster.desktop::-webkit-scrollbar-track {
  background: #666666;
  border: 0px none #ffffff;
  border-radius: .25rem;
}
.collection-cluster.desktop::-webkit-scrollbar-track:hover {
  background: #666666;
}
.collection-cluster.desktop::-webkit-scrollbar-track:active {
  background: #333333;
}
.collection-cluster.desktop::-webkit-scrollbar-corner {
  background: transparent;
}
</style>